import React from "react";
import { useTranslation } from "react-i18next";

const TierAccessToBenefitGroupRemoved = ({ notification }) => {
  const { t } = useTranslation();

  const benefitName = notification?.payload?.benefitName || "";

  return (
    <>
      <h4 className="notification-title">
        {t("notification_tier_access_to_benefit_group_removed_title", { benefitName })}
      </h4>
      <p className="notification-subtitle">
        {t("notification_tier_access_to_benefit_group_removed_subtitle")}
      </p>
      <p className="subtitle-description">
        {t("notification_tier_access_to_benefit_group_removed_description")}
      </p>
    </>
  );
};

export default TierAccessToBenefitGroupRemoved;
